import {
  AUDIT_LOG_REQUEST,
  AUDIT_LOG_SUCCESS,
  AUDIT_LOG_ERROR,
} from "../types";

const initialState = {
  items: [],
  totalElements: 0,
  isFetching: false,
  error: null,
};

export default function auditLogReducer(state = initialState, action) {
  switch (action.type) {
    case AUDIT_LOG_REQUEST:
      return { ...state, isFetching: true, error: null };
    case AUDIT_LOG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: action.payload.items,
        totalElements: action.payload.totalElements,
      };
    case AUDIT_LOG_ERROR:
      return { ...state, isFetching: false, error: action.payload };
    default:
      return state;
  }
}
